function setHasPaymentToken(state, hasPaymentToken) {
  state.hasPaymentToken = hasPaymentToken;
}

function setActiveOrders(state, activeOrders) {
  state.activeOrders = activeOrders;
}

export default { setHasPaymentToken, setActiveOrders };
